<form class="plan-shipment_create w-100 pe-5" [formGroup]="planShipmentForm">
  <div class="d-flex align-items-end gap-3">
    <div class="input-container warehouse-inputfield">
      <label for="" class="input-container_label font-600">From Warehouse</label>
      <div class="d-flex align-items-center gap-3">
        <div [ngClass]="{'warehouse_error' : !warehouse,'warehouse-size' :warehouse}">
          <mat-select class="input-container_input input-container_input--select" disableOptionCentering
            formControlName="fromWareHouseId">
            <mat-select-trigger>
              <span> {{planShipmentForm.controls["fromWareHouseId"].value?.id}} <small
                  class="whAddress-text">({{planShipmentForm.controls["fromWareHouseId"].value?.city}}
                  {{planShipmentForm.controls["fromWareHouseId"].value?.state}}) </small> </span>
            </mat-select-trigger>
            <mat-option *ngFor="let warehouse of warehouse$ | async" [value]="warehouse">
              {{ warehouse.id }} <small
                class="whAddress-text">({{warehouse.city}},{{warehouse.state}})</small></mat-option>
          </mat-select>
        </div>
        <app-button class="warehouse-btn" [buttonSize]="'action'" [buttonColor]="'primary'"
          (click)="createNewWarehouse('edit', planShipmentForm.controls['fromWareHouseId'].value)"
          *ngIf="planShipmentForm.controls['fromWareHouseId'].value"><i class="fal fa-edit"></i></app-button>
        <app-button [buttonSize]="'action'" [buttonColor]="'primary'" (click)="createNewWarehouse('New')"><i
            class="fal fa-plus"></i></app-button>
      </div>

    </div>
    <mat-tab-group class="custom-mat-default" animationDuration="0ms" [selectedIndex]="0"
      (selectedTabChange)="onTabChanged($event)">
      <mat-tab label="Random Address">
        <div class="plan-shipment_select">
          <div class="input-container">
            <label for="" class="input-container_label font-600">Try with a random address <i class="fas fa-info-circle ms-1"
              matTooltip="In some cases, a different shipping address may give you a different set of fulfillment centers.            
            Note: the shipment will be created with the 'from warehouse' address, not the random address."></i></label>
            <input type="text" class="input-container_input" [formControl]="WhsByCity" [matAutocomplete]="auto"
              placeholder="Search..." />
            <mat-autocomplete class="mat-select-panel" #auto="matAutocomplete" [displayWith]="displayWith"
              (optionSelected)="randomSelected()">
              <mat-option *ngFor="let option of filteredOptions" [value]="option">
                {{ option.city }} <small class="whAddress-text">({{option.state}},{{option.zip}})</small>
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Target Fulfilment Center">
        <div class="plan-shipment_select">
          <div class="input-container">
            <label for="" class="input-container_label font-600 mb-1">Target Fulfilment Center
              </label>
            <input type="text" class="input-container_input" [formControl]="targetFCControl" [matAutocomplete]="auto1"
              placeholder="Search." />
            <mat-autocomplete class="mat-select-panel" #auto1="matAutocomplete" [displayWith]="fcdisplayWith"
              (optionSelected)="targetSelected()">
              <mat-option *ngIf="!targetFulfilmentCentres?.length" aria-disabled="true"> No options found</mat-option>
              <mat-option class="fcWarehouse-option" *ngFor="let option of targetFulfilmentCentres" [value]="option">
                <div>
                  {{ option.fulfillmentCenterId }} <small
                    class="whAddress-text">({{option.state}},{{option.zip}})</small><br>
                    <small>Recommendations: {{option.recommendationsAmount}}</small>
                </div>
                <div class="fcWarehouse-icon" [ngClass]="{'disabled': option.disableButton}"
                  [ngClass]=" option.isFavourite ? 'active' : ''"
                  (click)="option.isFavourite ? deleteFavoriteFC($event,option) : addFavoriteFC($event,option)">
                  <i class="fas fa-star"></i>
                </div>
              </mat-option>
            </mat-autocomplete>
          </div>
        

        <div class="input-container warehouse-size select-opt-type" *ngIf="targetFCControl?.value?.fulfillmentCenterId">
          <label for="" class="input-container_label font-600">Suggested Address
            <i class="fas fa-info-circle ms-1" matTooltip="Use the options below to try getting the target FC (or one nearby), If unsuccessful, retry in 5 minutes."></i>
          </label>
          <mat-select class="input-container_input input-container_input--select" disableOptionCentering
            [(ngModel)]="selectedAddress" (ngModelChange)="onChange($event)" [ngModelOptions]="{standalone: true}">
            <mat-select-trigger>
              <span *ngIf="selectedAddress"> {{selectedAddress.displayName}}<small class="whAddress-text">({{selectedAddress.state}}) </small> </span>
            </mat-select-trigger>
            <mat-option *ngIf="!locationRecommendations?.length" aria-disabled="true"> 0 rows,check back later</mat-option>
            <mat-option *ngFor="let address of locationRecommendations; let i = index" [value]="address">
              <div> {{ address.displayName}} <small class="whAddress-text">&nbsp;({{address.state}})</small></div>
            </mat-option>
          </mat-select>
        </div>
      </div>
      </mat-tab>     
    </mat-tab-group>
  </div>
</form>
